module.exports = __webpack_public_path__ + "img/iphone-map-FRANCE-fr.5b5b20ec.png";